import axios from 'axios';
import styled from 'styled-components';
import { PointsContext } from './pointContext';
import { PriceContext } from '../context';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from "chart.js/auto";
import { useState, Fragment, createContext, useContext, useEffect ,  useRef } from 'react';
import { authenticate } from '../authenticate';
import useSliderStore from '../config/useStore'

const FormContainer = styled.div`
  grid-area: form;
  ${props => (props.disabled || !props.isAuthenticated) && `
    pointer-events: none;
    opacity: 0.5;
  `}
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
  width: 100%;
  background: linear-gradient(to bottom, #505a62, #40484f);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Adds a subtle 3D effect */
  margin-bottom: 20px; /* Creates space below the container */
  border-radius: 8px; /* Optional: rounded corners for a softer look */
`;
const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f0f0f0; /* Light gray background that pairs well */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2); /* Deeper shadow for more depth */
  /* Optional: add a slight border or gradient for extra effect */
`;
const StyledInput = styled.input`
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 16px;
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  color: #ffffff;
  background-color: #007bff; /* Bright blue to stand out */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Adds depth */
  transition: background-color 0.3s, box-shadow 0.3s; /* Smooth hover transition */

  &:hover {
    background-color: #0056b3; /* Darker blue on hover */
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2); /* Slightly more prominent shadow on hover */
  }
`;

const Message = styled.div`
  margin-top: 20px;
  color: red;
`;
  const PlayerForm = ({oldPlayer,setOld,setDates, setPoints, setAssists, setRebounds, setTeams, player, setPointsPred_l, setAssistsPred_l,setReboundsPred_l}, points)  => {
  const [pstats, setPstats] = useState('');
  const [readOnly, setReadOnly] = useState(false);

  const {credit, setCredit, disabled, setDisable, isAuthenticated,message, setMessage, email, setSubs, setSubTeams, subs} = useContext(PriceContext);
  const { setReboundsEndIndex,setReboundsStartIndex,setAssistsEndIndex, setAssistsStartIndex,setEndIndex, setStartIndex, playerName, setPlayerName} = useContext(PointsContext);
  const close = useSliderStore((state) => state.close);

  
useEffect(() => {
  const initialize = async () => {
    setReadOnly(true);
    // await grabCredits()
    // fetchSubscriptions();
    // The rest of your logic...
    if (!isAuthenticated) {
      // setMessage('Login to use')
      setOld('Lebron James');
    } else {
      if (disabled) {
        setMessage('add more credits');
      } else {
        setMessage('');
      }
    }
  };

  initialize();
  
  // The synchronous function passed to useEffect should return a cleanup function or nothing.
  // We return nothing, so it will only run once on mount (in production).
}, []);

// Start of from account 
function removeDuplicates(arr) {
    return [...new Set(arr)];
}

function getUniqueTeams(teamList) {
  const allTeams = teamList.flatMap(str => str.split(','));
  const uniqueTeams = [...new Set(allTeams)];
  return uniqueTeams;
}


function subscribedTeams(subs) {
  const sub_teams = []
  const now = new Date();

  for (const item of subs) {
    const subscriptionEnd = new Date(item.subscription_end);

    if (subscriptionEnd < now) {
      const timeDiff = now.getTime() - subscriptionEnd.getTime();
      const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hoursDiff = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));


    } else {

      sub_teams.push(item.teams)

    }
  }
const non_dup_teams = removeDuplicates(sub_teams)
const full_non_dup_teams = getUniqueTeams(non_dup_teams)
return full_non_dup_teams
}
    const fetchSubscriptions = async () => {
    grabCredits()
       axios({
        method: 'post',
        url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
       
        withCredentials: false,
        data: {
          email:email,
          path:'grab-sub',

        },
      }).then(function (response) {
         const data = response.data;
         console.log('sub data')
        console.log(data)
        setSubs(data)
      
        console.log('the subs', subs)
        let team_list = subscribedTeams(subs)
        setSubTeams(team_list)
    
      })
      .catch(function (error) {
      });
    }

// end of from account
    async function spendCredit() {
      try {
        axios({
          method: 'post',
          url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
         
          withCredentials: false,
          data: {
            email:email,
            path:'user-spend-credit'
          },
        }).then(function (response) {
          
        })
        .catch(function (error) {
        });
  
  
  
      } catch (error) {
          console.error('Error:', error);
      }
  }

  async function grabCredits() {
    console.log('trying to get credits')
    try {
      axios({
        method: 'post',
        url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
       
        withCredentials: false,
        data: {
          email:email,
          path:'user-credit-load'
        },
      }).then(function (response) {
         const data = response.data;
         console.log('credits left')
        let credits_purchased = Number(data);
        console.log('le credits', credits_purchased)
        setCredit(credits_purchased);
        setTimeout(() => {
            // Código a ejecutar después de 1 segundo
        }, 5000);
      })
      .catch(function (error) {
      });



    } catch (error) {
        console.error('Error:', error);
    }
}

  
  function combineColumns(row) {
    const year = String(row.year);
    const month = String(row.month).padStart(2, '0');
    const day = String(row.day).padStart(2, '0');
    const cleanDate = `${year}-${month}-${day}`;
    return cleanDate;
  }


  function orderListByDates(dates, listToOrder, order = 'asc') {
    // Combine the dates and the other list into a single array of objects
    const combined = dates.map((date, index) => ({ date, value: listToOrder[index] }));
  
    // Sort the combined array by date
    combined.sort((a, b) => {
      if (order === 'asc') {
        return a.date.localeCompare(b.date);
      } else {
        return b.date.localeCompare(a.date);
      }
    });
  
    // Extract the sorted list
    const orderedList = combined.map(item => item.value);
  
    return orderedList;
  }

  async function assists_pred(x){

    setAssistsPred_l('computing prediciton...')
    axios({
      method: 'post',
        url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
    
      withCredentials: false,
      data: {
      player:x,
        path:'assists'
      },
    }).then(function (response) {
      let res = response.data
      let numbers_res = res.match(/[\d.]+/g);
      let numbers_list = numbers_res.map(Number);
      console.log('nummm', numbers_list)
      setAssistsPred_l(numbers_list[0])
      // linear is 1, tree is 0


    })
    .catch(function (error) {
    });

 }


 async function rebounds_pred(x){

  setReboundsPred_l('computing prediciton...')
  axios({
    method: 'post',
      url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
  
    withCredentials: false,
    data: {
    player:x,
      path:'rebounds'
    },
  }).then(function (response) {
    let res = response.data
    let numbers_res = res.match(/[\d.]+/g);
    let numbers_list = numbers_res.map(Number);
    setReboundsPred_l(numbers_list[0])


  })
  .catch(function (error) {
  });

}

 async function points_pred(x){

    setPointsPred_l('computing prediciton...')
    axios({
      method: 'post',
        url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
    
      withCredentials: false,
      data: {
      player:x,
        path:'points'
      },
    }).then(function (response) {
      let res = response.data
      let numbers_res = res.match(/[\d.]+/g);
      let numbers_list = numbers_res.map(Number);
      setPointsPred_l(numbers_list[0])
      


    })
    .catch(function (error) {
    });

 }
  
  async function grab_pred(x){
     assists_pred(x)
      points_pred(x)
     
      rebounds_pred(x)
  
  }
    const enableInput = () => {
      setReadOnly(true)
  };
  async function load_player (x) {


    //  await grab_pred(x);
     let player = x;
     
     axios({
      method: 'post',
      url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/nba`,
      withCredentials: false,
      data: {
      player:player,
        path:'player-data'
      },
    }).then(function (response) {
      let data = response.data
      console.log("the data is here", data)
      let mdates = []
      let spoints = []
      let srebounds = []
      let sassists = []
      let steams = []
      for (let i = 0; i < data.length; i++) {
       
      
        let d = combineColumns(data[i])
        let p = data[i].points
        let t = data[i].total_rebounds
        let a = data[i].assists
        let v = data[i].opposing_team
        mdates.push(d)
        spoints.push(p)
        srebounds.push(t)
        sassists.push(a)
        steams.push(v)
      }
      let ordered_points = orderListByDates(mdates, spoints,'asc')
      let ordered_assists = orderListByDates(mdates, sassists,'asc')
      let ordered_rebounds = orderListByDates(mdates, srebounds,'asc')
      let ordered_teams = orderListByDates(mdates, steams,'asc')
      // default is asc
      mdates = mdates.sort()
      console.log('mdates length',mdates.length)

      setEndIndex(mdates.length -1)
      setStartIndex(mdates.length - 5)
      setAssistsEndIndex(mdates.length -1)
      setAssistsStartIndex(mdates.length-5)
      setReboundsEndIndex(mdates.length -1)
      setReboundsStartIndex(mdates.length-5)



      setDates(mdates)
      setPoints(ordered_points)
      setAssists(ordered_assists)
      setRebounds(ordered_rebounds)
      setTeams(ordered_teams)
  
    })
    .catch(function (error) {
    });
    



  }
  const handleSubmit = (event) => {
    event.preventDefault();
    close('points')
    close('assists')
    close('rebounds')


    setOld(playerName)
    if (playerName.length > 3){
      load_player(playerName); 
      grab_pred(playerName)
      }

      console.log('pred ran')
      console.log(points_pred)
      // spendCredit()

      // let  oldCredit = credit
      // let newCredit = oldCredit - 1
      // setCredit(newCredit)


      // if(credit == 1){
      //   setDisable(true)

      //   setMessage('Grab more Credits to use');
      // }
    // load_player(playerName)

  };


  return (
    <FormContainer disabled={false} isAuthenticated={true}>
      <StyledForm onSubmit={handleSubmit}>
        <StyledInput
          type="text"
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          placeholder={oldPlayer}
          onClick={enableInput}

          
        />

        <SubmitButton type="submit">Load Player</SubmitButton>
        {message && <Message>{message}</Message>}
      </StyledForm>
    </FormContainer>
  );
};

export default PlayerForm 